import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import useWasRenderedOnClientAtLeastOnce from './use-was-rendered-on-client';
import { measureHeight } from './utils/measure-height';
const use100vh = () => {
  const $ = _c(3);
  const [height, setHeight] = useState(measureHeight);
  const wasRenderedOnClientAtLeastOnce = useWasRenderedOnClientAtLeastOnce();
  let t0;
  let t1;
  if ($[0] !== wasRenderedOnClientAtLeastOnce) {
    t0 = () => {
      if (!wasRenderedOnClientAtLeastOnce) {
        return;
      }
      const setMeasuredHeight = function setMeasuredHeight() {
        const measuredHeight = measureHeight();
        setHeight(measuredHeight);
      };
      window.addEventListener("resize", setMeasuredHeight);
      return () => {
        window.removeEventListener("resize", setMeasuredHeight);
      };
    };
    t1 = [wasRenderedOnClientAtLeastOnce];
    $[0] = wasRenderedOnClientAtLeastOnce;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return wasRenderedOnClientAtLeastOnce ? height : null;
};
export default use100vh;